module.exports = __webpack_public_path__ + "assets/img/nourishing_soup_active.2f71a619.png";